export default function capitalizeFilter(text) {
  //Type checking to avoid non-strings
  if (typeof text !== 'string') return text;

  return text.replace(/(^|\s)\S/g, function (t) {
    return t.toUpperCase();
  });
}
